
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import useTranslation from "next-translate/useTranslation";

export default function PrivacyPolicyPage() {
  const { t } = useTranslation("privacy-policy");
  const privacyPolicy = t("privacy-policy", {}, { returnObjects: true });

  return (
    <article id="privacy-policy">
      <div className="d-flex col ai-c jc-c gp-64">
        <h3>{privacyPolicy.title}</h3>
        <div className="d-flex col ai-c jc-c gp-32">
          {privacyPolicy.policy.map((text, id) => {
            return <span key={id}>{text}</span>;
          })}
        </div>
      </div>
    </article>
  );
}


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/privacy-policy/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  